import React from "react";

export const HowToIcon: React.FC = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    role="img"
  >
    <title>How To - graduation cap icon</title>
    <g
      fill="none"
      stroke="#5C6A7A"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3 L22 8 L12 13 L2 8 Z" />
      <path d="M6 10.5 L6 16.5 Q12 19.5 18 16.5 L18 10.5" />
      <line x1="22" y1="8" x2="22" y2="14" />
    </g>
  </svg>
);
